module.exports = __webpack_public_path__ + "img/role-dinosaur.309252ec.png";